export enum PermanentJobOfferStatusEnum {
    Accepted = 1,
    Declined = 2,
    Pending = 3,
    Placed = 4
}

 interface PostOfferInformationBase {
    billingAmount?: number | null;
    jobOfferStatus?: PermanentJobOfferStatusEnum | null;
 }

export interface PostOfferInformationSerializable extends PostOfferInformationBase {
    offerDate?: string | null;
    startDate?: string | null;
}

export interface PostOfferInformation extends PostOfferInformationBase {
    offerDate?: Date | null;
    startDate?: Date | null;
}
